import React, { useEffect, useState } from "react";
import style from "./style.module.css";
import img1 from "../../assets/healthimg.jpg";
import DoneIcon from "@mui/icons-material/Done";
import EmailIcon from "@mui/icons-material/Email";
import CallIcon from "@mui/icons-material/Call";
import { AutocompleteSelect } from "../../components/AutocompleteSelect";
import { Application_Type } from "../../components/Constant/constants";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { useNavigate, useParams } from "react-router-dom";
import { getProgrammeDetailsById } from "../../Api/commonApi";
import { loader } from "../../store/utilities";
export default function ProgrammeDetails() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [getAllData, setGetAllData] = useState({});
  const [findProgrammeData, setFindProgrammeData] = useState();
  {console.log(findProgrammeData)}
  const getAllDataFunction = async () => {
    loader.start();
    try {
      let response = await getProgrammeDetailsById(id).then(
        (res) => res.data.data
      );
      setGetAllData(response);
      console.log(response);
    } catch (err) {
      console.error("Error fetching data", err);
    } finally {
      loader.stop();
    }
  };

  useEffect(() => {
    getAllDataFunction();
  }, []);
  return (
    <>
      <div className={style.mainContainer}>
        <div
          className={`${style.main_Heading_programme} d-flex justify-content-center`}
        >
          <div className={`${style.main_heading_style}`}>Programme Details</div>
        </div>
        <div className="row mt-4 px-2 gap-2">
          <div className="col-lg-3 col-md-12 card">
            <div className={`${style.Image_section}`}>
              <img
                src={getAllData?.logo?.fileUrl}
                alt=""
                style={{ width: "100%", height: "200px" }}
              />
            </div>
            <div className="d-flex flex-column justify-content-center">
              <div className={`${style.sub_heading} d-flex `}>
                {getAllData?.name}
              </div>
              <div className="mt-2">
                Currently offered at {getAllData?.mergedInfo?.length}{" "}
                institution(s).
              </div>
            </div>
            <hr />
            <div>
              <div className="">This course includes:</div>
            </div>
            <div className="d-flex mt-2">
              <div>
                <DoneIcon />
              </div>
              <div className="ms-2">{getAllData?.award}</div>
            </div>
            <div className="d-flex mt-2">
              <DoneIcon />
              <div className="ms-2">{getAllData?.total_hours}</div>
            </div>
            {/* <div className="d-flex mt-2">
              <DoneIcon />
              <div className="ms-2">{getAllData?.description}</div>
            </div> */}
            <div className="d-flex mt-3">
              <div>
                <EmailIcon />
              </div>
              <div className="ms-2">info@lmis.org</div>
            </div>
            <div className="d-flex mt-3">
              <div>
                <CallIcon />
              </div>
              <div className="ms-2">(876)-99-90909-989</div>
            </div>
            <div className={`mt-4 mb-2 d-flex justify-content-center`}>
              {findProgrammeData? <button
                className={`btn ${style.choose_institution}`}
                onClick={() => {
                  navigate(`/onlineApplication/${findProgrammeData?._id}`,{state:{fullData:getAllData,programmeData:findProgrammeData}});
                }}
              >
                Application Apply
              </button>: <button
                className={`btn ${style.choose_institution}`}
                // onClick={() => {
                //   navigate("/onlineApplication");
                // }}
              >
                Choose an Institution!
              </button>}
             
            </div>
          </div>
          <div className="col-lg-8 col-md-12 card">
            <div className={`${style.subHeading_section_two}`}>
              {getAllData?.name}
            </div>
            <div className={`${style.paragraph_style} mt-3`}>
              {getAllData?.description}
            </div>
            <hr />
            <div className="px-3">
              <div
                className={`${style.first_container_right_section} row mt-3 align-items-center`}
              >
                <div className="col-md-6">
                  Currently being offered at {getAllData?.mergedInfo?.length}{" "}
                  institution(s). Select from the dropdown:
                </div>

                <div className="col-md-6">
                  <AutocompleteSelect
                    label={"Select an Institution and Offering"}
                    getOptionLabel={(option) => option.label || ""}
                    options={getAllData?.mergedInfo?.map((res) => {
                      return {
                        label: res?.institute_name,
                        value: res?._id,
                        obj: res,
                      };
                    })}
                    style={{
                      border: "1px solid black",
                      borderRadius: "8px",
                      backgroundColor: "white",
                    }}
                    onChange={(e, value) => {
                      console.log(value);
                      setFindProgrammeData(value?.obj);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="px-1 mt-3">
              <div className={`${style.second_container_right_section}`}>
                <div className={`${style.campus_heading}`}>
                  {`${findProgrammeData?.institute_name} ${findProgrammeData?.institute_address}`}
                </div>
                <div className={`${style.programme_cost_style} mt-1`}>
                  Programme Cost: $ {findProgrammeData?.amount}
                </div>
                <div className="text_underline_style mt-1">
                  Contact Person: {findProgrammeData?.contect_person_name}
                </div>
                <div className="text_underline_style mt-1">
                  Tel: {findProgrammeData?.contect_person_number}
                </div>
                <div className="text_underline_style mt-1">
                  email: {findProgrammeData?.contect_person_email}
                </div>
                <div className="text_underline_style mt-1">
                  Award: {getAllData?.award}
                </div>
                <div className="text_underline_style mt-2">
                  Total Hours: {getAllData?.total_hours}
                </div>
                <div className="text_underline_style mt-2">
                  Full-Time, Face to Face Modality | Duration:{" "}
                  {findProgrammeData?.duration?.from} to{" "}
                  {findProgrammeData?.duration?.to}
                </div>
              </div>
            </div>
            <div className="px-1 mt-3 mb-2">
              <div className={`${style.third_container_right_section}`}>
                <div className="fw-600 fs-5">Programme Units</div>
              </div>
              
              {findProgrammeData?.units?.map((data,index) => {
                return (
                  <>
                    <div className={index%2 === 0 ?`${style.fifth_container_right_section}`:`${style.fourth_container_right_section}`}>
                      <div className="d-flex align-items-center">
                        <div>
                          <FiberManualRecordIcon />
                        </div>
                        <div className="d-flex flex-column ms-2">
                          <div className={`${style.apply_unit_heading}`}>
                            {data?.unit_title}
                          </div>
                          <div>{data?.duration}</div>
                        </div>
                      </div>
                    </div>
                  </>
                );
              })}

              {/* <div className={`${style.fifth_container_right_section}`}>
                <div className="d-flex align-items-center">
                  <div>
                    <FiberManualRecordIcon />
                  </div>
                  <div className="d-flex flex-column ms-2">
                    <div className={`${style.apply_unit_heading}`}>
                      APPLY BASIC COMMUNICATION SKILLS
                    </div>
                    <div>30 Unit Hours</div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
